import Vue from 'vue'
import VuePreview from 'vue-preview'
import store from '@/store'
import router from '@/router'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import App from '@/App'
import Table from '@/components/buefy/Table'

Vue.config.productionTip = false
// Vue.prototype.$http.defaults.headers.common['accept'] = 'application/ld+json'

Vue.use(VuePreview)

Vue.use(Buefy, {
	defaultSnackbarDuration: 5000,
	defaultToastDuration: 5000,
	defaultNoticeQueue: false
})
Vue.component(Table.name, Table)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
